import React from "react";
import { motion } from "framer-motion";
import { useSpotsLeft } from "../hooks/useOffer";
type ScarcityBarProps = {
  tone?: "light" | "dark";
};
export function ScarcityBar({
  tone = "dark"
}: ScarcityBarProps) {
  const {
    left,
    percent
  } = useSpotsLeft();
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-xl" data-id="element-298" data-mp="2q37ot6zqrd8f">
      <p className={`text-center text-base font-semibold ${dark ? "text-white" : "text-ink"}`} data-id="element-299" data-mp="2q269urflu6lf">
        Only <span className="rounded bg-alert px-1.5 py-0.5 font-bold text-white" data-id="element-300" data-mp="2b8ur3pf96bzc">{left} spots left</span> at the
        promotional price
      </p>
      <div className={`mt-3 h-5 w-full overflow-hidden rounded-full ${dark ? "bg-white/15" : "bg-navy-900/10"}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-301" data-mp="226lg6yg2oglf">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-cta pr-2" initial={{
        width: "80%"
      }} animate={{
        width: `${percent}%`
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-302" data-mp="5didv525sbl0">
          <span className="text-[11px] font-bold text-navy-950" data-id="element-303" data-mp="2zj70y5lp2nml">{percent}% claimed</span>
        </motion.div>
      </div>
    </div>;
}